import React from 'react'
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { DatePickerInput } from '../DatePickerInput/DatePickerInput'
import { format } from 'date-fns'
import { Typography } from '@mui/material'

type DatePickerCustomProps = {
  value: Date | null
  onChange: (date: Date | null) => void
  onClear?: () => void
  placeholder?: string
  label?: string
  containerStyle?: React.CSSProperties
}

// Наследуем ВСЁ остальное от ReactDatePickerProps, кроме конфликтующих
export interface DatePickerProps
  extends Omit<ReactDatePickerProps, 'selected' | 'onChange' | 'customInput' | 'value'>,
    DatePickerCustomProps {}

export const DatePicker = React.forwardRef<HTMLDivElement, DatePickerProps>(
  ({ value, onChange, onClear, placeholder, label, containerStyle, ...restProps }, ref) => {
    // Форматируем отображаемое значение (можно вынести в хук или пропс)
    const displayValue = value ? format(value, 'MMM d, yyyy H:mm') : undefined

    return (
      <div style={containerStyle}>
        {label && (
          <Typography variant="body2" sx={{ color: '#6B7280' }}>
            {label}
          </Typography>
        )}

        <ReactDatePicker
          //ref={ref}
          selected={value}
          onChange={onChange}
          showTimeSelect
          timeIntervals={60}
          dateFormat="MMMM d, yyyy HH:mm"
          timeFormat="HH:mm"
          customInput={<DatePickerInput ref={ref} value={displayValue} placeholder={placeholder} onClear={onClear} />}
          {...restProps}
        />
      </div>
    )
  },
)

DatePicker.displayName = 'DatePicker'
